import { proxy } from 'valtio'

const globalStore = proxy({ collapsed: false })

export default globalStore
